module.exports = "pegasus_template/assets/roundrect-facebook.png";